import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDateParserFormatter, NgbCalendar, NgbDate, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from './dateformat';
import { datepickerI18n } from './datepickerI18n';
import { maxLengthF, maxLengthL, ValidateName } from '../validators/personalInfo-about-yourself.validator';

export enum UI_GENERATION {
  BORROWER = 'Borrower',
  CO_BORROWER = 'Co_Borrower',
  BOTH = 'Both'
}

@Component({
  selector: 'personal-information-about-yourself',
  templateUrl: './personal-information-about-yourself.component.html',
  styleUrls: ['./personal-information-about-yourself.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig, { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }, { provide: NgbDatepickerI18n, useClass: datepickerI18n }]
})
export class personalInformationAboutYourselfComponent implements OnInit {
  currentLang: string;
  currentRoutePath: string;
  productFlow: string;
  applicantName: any;
  applicantUserObj: any;
  coApplicantUserObj: any;
  preQualObj: any;
  colorForTb: boolean = true;
  loader: boolean = false;
  aboutForm: FormGroup;
  coapplicantAboutForm: any;
  submitted: boolean = false;
  coSubmitted: boolean = false;
  maxPickerDate: any
  minPickerDate: any
  nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  month_en: any;
  month_fr: any;
  isIos: boolean;
  isAndroid: boolean;
  isCoapplicantApplied: boolean;
  isExistingCustomer: boolean;
  areBothCibcCustomer: boolean;
  suffixList: any;
  currLangEn = 'en';
  currLangFr = 'fr';
  prequalType = 'P';
  switchType = 'S';


  constructor(private el: ElementRef, private fb: FormBuilder, private calendar: NgbCalendar,
    private util: UtilService, private _activatedRoute: ActivatedRoute, private router: Router) {

    this.month_en = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
    this.month_fr = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'];
    this.suffixList = ["Jr", "Sr", "II", "III", "IV", "V"];

    this.aboutForm = this.fb.group({
      firstName: ['', [Validators.required, ValidateName, maxLengthF]],
      lastName: ['', [Validators.required, ValidateName, maxLengthL]],
      suffix: [''],
      DOB: ['', Validators.required]
    })

    this.coapplicantAboutForm = this.fb.group({
      firstName: ['', [Validators.required, ValidateName, maxLengthF]],
      lastName: ['', [Validators.required, ValidateName, maxLengthL]],
      suffix: [''],
      DOB: ['', Validators.required]
    })

    this.maxPickerDate = {
      year: (new Date()).getFullYear() - 18,
      month: (new Date()).getMonth() + 1,
      day: new Date().getDate()
    }

    this.minPickerDate = {
      year: (new Date()).getFullYear() - 110,
      month: (new Date()).getMonth() + 1,
      day: new Date().getDate()
    }


    /**
     * Check if this screen is for primary or co-applicant and set the progress percentage
     */
    this.preQualObj = this.util.getSessionStorage();
    this.isCoapplicantApplied = this.preQualObj.is_coapplicant_applied == 'Y' ? true : false;
    this.isExistingCustomer = this.preQualObj.is_existing_bankcustomers == 'Y' ? true : false;
    this.areBothCibcCustomer = this.preQualObj.are_both_applicants_CIBC_customer == 'Y' ? true : false;
    let progressPercent1 = sessionStorage.getItem("progressPercentage");
    let curLng = sessionStorage.getItem("currLang");
    let objSession = this.util.getSessionStorage();
    if (curLng != objSession.lang_pref) {
      this.router.navigate(['../' + curLng + '/home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });
  }
  ngOnInit(): void {
    this.preQualObj = this.util.getSessionStorage();
    if (!this.preQualObj.users) {
      this.preQualObj.users = []
    } else {
      this.preQualObj.users.forEach(obj => {
        if (obj.main_application == 0) {
          this.applicantUserObj = obj;
        } else {
          this.coApplicantUserObj = obj;
        }
      })
    }

    this.currentLang = sessionStorage.getItem("currLang");
    if (sessionStorage.getItem("routeBack") == "true") {
      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (this.isCoapplicantApplied && this.isExistingCustomer)) {
        this.coapplicantAboutForm.controls.firstName.setValue(this.coApplicantUserObj.firstname);
        this.coapplicantAboutForm.controls.lastName.setValue(this.coApplicantUserObj.lastname);
        this.coapplicantAboutForm.controls.suffix.setValue(this.coApplicantUserObj.suffix);
        let coapplicantDate = this.coApplicantUserObj.date_of_birth.split("-");
        const coapplicantObjBeginDate = { year: Number(coapplicantDate[0]), month: Number(coapplicantDate[1]), day: Number(coapplicantDate[2]) };
        this.coapplicantAboutForm.controls.DOB.setValue(coapplicantObjBeginDate);
      }
      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (!this.isCoapplicantApplied && !this.isExistingCustomer)) {
        this.aboutForm.controls.firstName.setValue(this.applicantUserObj.firstname);
        this.aboutForm.controls.lastName.setValue(this.applicantUserObj.lastname);
        this.aboutForm.controls.suffix.setValue(this.applicantUserObj.suffix)
        let date = this.applicantUserObj.date_of_birth.split("-");
        const objBeginDate = { year: Number(date[0]), month: Number(date[1]), day: Number(date[2]) };
        this.aboutForm.controls.DOB.setValue(objBeginDate);
      }
    }
    /*if (this.isIos) {
      if (sessionStorage.getItem("tempAboutYourselve")) {
        let details = JSON.parse(sessionStorage.getItem("tempAboutYourselve"));
        this.aboutForm.controls.firstName.setValue(details.firstname);
        this.aboutForm.controls.lastName.setValue(details.lastname);
        let date = details.date_of_birth.split("-");
        const objBeginDate = { year: Number(date[0]), month: Number(date[1]), day: Number(date[2]) };
        this.aboutForm.controls.DOB.setValue(objBeginDate);
      }
    }*/
    document.getElementById("sidebarTitle").focus();
    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    this.isAndroid = !!navigator.platform && /Linux/.test(navigator.platform);
  }


  isDisabled = (date: NgbDate, current: { month: number, year: number }) => date.month !== current.month;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;
  get f() {
    return this.aboutForm.controls;
  }
  get cf() {
    return this.coapplicantAboutForm.controls;
  }

  onContinue() {
    this.submitted = true;
    this.coSubmitted = true;
    let f = this.aboutForm.controls;
    let cf = this.coapplicantAboutForm.controls;
    let sessionObj = this.util.getSessionStorage();
    if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
      var applicantDateOfBirth = this.getDateOfBirth(this.aboutForm);
    }

    if (this.isCoapplicantApplied || this.isExistingCustomer) {
      var coApplicantDateOfBirth = this.getDateOfBirth(this.coapplicantAboutForm);
    }

    if (this.isIos) {
      sessionStorage.removeItem("tempAboutYourselve");
      sessionStorage.removeItem("tempAboutCoapplicant");
    }

    let users = {
      "main_application": 0,
      "is_existing_bankcustomer": "N",
      "customer_id": "",
      "firstname": this.aboutForm?.value?.firstName.toUpperCase(),
      "middlename": "",
      "lastname": this.aboutForm?.value?.lastName.toUpperCase(),
      "suffix": this.aboutForm?.controls?.suffix?.value,
      "date_of_birth": applicantDateOfBirth,
      "addressline1": "",
      "addressline2": "",
      "city": "",
      "province": "",
      "country_code": 146,
      "postal_code": "",
      "mobilenumber": "",
      "homenumber": "",
      "email": "",
      "cb_consent": "",
      "ip_address": "",
      "cb_datetime": ""
    };

    let coapplicantUsers = {
      "main_application": 1,
      "is_existing_bankcustomer": "N",
      "customer_id": "",
      "firstname": this.coapplicantAboutForm?.value?.firstName.toUpperCase(),
      "middlename": "",
      "lastname": this.coapplicantAboutForm?.value?.lastName.toUpperCase(),
      "suffix": this.coapplicantAboutForm?.controls?.suffix?.value,
      "date_of_birth": coApplicantDateOfBirth,
      "addressline1": "",
      "addressline2": "",
      "city": "",
      "province": "",
      "country_code": 146,
      "postal_code": "",
      "mobilenumber": "",
      "homenumber": "",
      "email": "",
      "cb_consent": "",
      "ip_address": "",
      "cb_datetime": ""
    };

    if (!sessionObj.users) {
      sessionObj.users = [];
    };
    if (sessionStorage.getItem("routeBack") == "true") {

      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (this.isCoapplicantApplied && this.isExistingCustomer)) {
        this.coApplicantUserObj.firstname = this.coapplicantAboutForm.value.firstName.toUpperCase();
        this.coApplicantUserObj.lastname = this.coapplicantAboutForm.value.lastName.toUpperCase();
        this.coApplicantUserObj.suffix = this.coapplicantAboutForm.value.suffix;
        this.coApplicantUserObj.date_of_birth = coApplicantDateOfBirth;
      }

      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (!this.isCoapplicantApplied && !this.isExistingCustomer)) {
        this.applicantUserObj.firstname = this.aboutForm.value.firstName.toUpperCase();
        this.applicantUserObj.lastname = this.aboutForm.value.lastName.toUpperCase();
        this.applicantUserObj.suffix = this.aboutForm.value.suffix;
        this.applicantUserObj.date_of_birth = applicantDateOfBirth;

      }
      sessionObj.users.forEach((user, index) => {
        if (user.main_application == 0) {
          sessionObj.users[index] = this.applicantUserObj;
        } else {
          sessionObj.users[index] = this.coApplicantUserObj;
        }
      })


    } else {
      if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
        sessionObj.users.push(users);
      }
      if (this.isCoapplicantApplied || this.isExistingCustomer) {
        sessionObj.users.push(coapplicantUsers);
      }

    }

    if (this.preQualObj.flow_type == this.switchType) {
      var errorArray = [];
      if ((this.isCoapplicantApplied || !this.isCoapplicantApplied) && !this.isExistingCustomer) {
        for (const key in f) {
          if (f[key].errors && f[key]) {
            var msgType = {
              type: (f[key].value != "") ? "invalid-characters" : "missing",
              field: key,
              subtype: "",
              code: ""
            }
            errorArray.push(msgType);

          }
        }
      }
      if ((this.isCoapplicantApplied && !this.isExistingCustomer)) {
        for (const key in cf) {
          if (cf[key].errors && cf[key]) {
            var msgType = {
              type: (cf[key].value != "") ? "invalid-characters" : "missing",
              field: key,
              subtype: "",
              code: ""
            }
            errorArray.push(msgType);
          }
        }
      }
      if (errorArray.length > 0) {
        this.util.adobeAnalyticalErrorMsg('', '', '', errorArray);
      }
    }

    const isApplicantValid = f?.firstName && f?.lastName && f?.DOB &&
      !f.firstName.errors?.invalidName && !f.firstName.errors?.required &&
      !f.lastName.errors?.invalidName && !f.lastName.errors?.required &&
      !f.DOB.errors?.required && !f.firstName?.errors && !f.lastName?.errors;

    const isCoApplicantValid = cf?.firstName && cf?.lastName && cf?.DOB &&
      !cf.firstName.errors?.invalidName && !cf.firstName.errors?.required &&
      !cf.lastName.errors?.invalidName && !cf.lastName.errors?.required &&
      !cf.DOB.errors?.required && !cf.firstName?.errors && !cf.lastName?.error;

    const isFormValid = (this.isCoapplicantApplied && !this.isExistingCustomer)
      ? (isApplicantValid && isCoApplicantValid)
      : (!this.isCoapplicantApplied ? isApplicantValid : isCoApplicantValid);

    if (isFormValid) {
      this.util.setSessionStorage(sessionObj);
      if (sessionStorage.getItem("routeBack") == "true") {
        this.router.navigate(['../personal-information-preview'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      } else {
        this.router.navigate([this.util.determineNextRoute(this.currentRoutePath)], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
    }



    for (const key of Object.keys(this.aboutForm.controls)) {
      if (this.aboutForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
        invalidControl.focus();
        break;
      }
    }
    if (this.isCoapplicantApplied && !this.isExistingCustomer) {
      for (const key of Object.keys(this.coapplicantAboutForm.controls)) {
        if (this.coapplicantAboutForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          invalidControl.focus();
          break;
        }
      }
    }
  }

  getDateOfBirth(formData) {
    let day = formData.value.DOB.day;
    if (day < 10) {
      day = "0" + day;
    }
    let month = formData.value.DOB.month;
    if (month < 10) {
      month = "0" + month;
    }
    let dateofbirth = formData.value.DOB.year + "-" + month + "-" + day;
    return dateofbirth
  }

  onDateSelect(event) {

    document.getElementById("cb").focus();
    const dob = document.querySelector('#cb');
    const dobTxtField = document.querySelector('#dp');
    var newDateb;
    if (this.currentLang == 'fr') {
      newDateb = event.day + " " + this.month_fr[event.month - 1] + "," + event.year;
    } else {
      newDateb = event.day + " " + this.month_en[event.month - 1] + "," + event.year;
    }
    if (dob.innerHTML.length == 0) {
      dob.setAttribute('aria-describedby', '');
    } else {
      dobTxtField.setAttribute('aria-label', newDateb);
      dob.setAttribute('aria-label', newDateb);
      dob.setAttribute('aria-describedby', 'dobSelected cb');
    }
  }

  onCoapplicantDateSelect(event) {

    document.getElementById("ccb").focus();
    const dob = document.querySelector('#ccb');
    const dobTxtField = document.querySelector('#cdp');
    var newDatecb;
    if (this.currentLang == 'fr') {
      newDatecb = event.day + " " + this.month_fr[event.month - 1] + "," + event.year;
    } else {
      newDatecb = event.day + " " + this.month_en[event.month - 1] + "," + event.year;
    }
    if (dob.innerHTML.length == 0) {
      dob.setAttribute('aria-describedby', '');
    } else {
      dobTxtField.setAttribute('aria-label', newDatecb);
      dob.setAttribute('aria-label', newDatecb);
      dob.setAttribute('aria-describedby', 'dobSelected ccb');
    }
  }
  ngAfterViewInit() {
    const calendar = document.querySelector('#cb');
    calendar.addEventListener('click', this.updateButtonTranslation);
    const coapplicantCalendar = document.querySelector('#ccb');
    coapplicantCalendar?.addEventListener('click', this.updateButtonTranslation);
  }
  selectDisable() {
    if (this.isIos || this.isAndroid) {
      const removeElement = document.querySelectorAll(".ngb-dp-day");

      removeElement.forEach(element => {
        element.removeAttribute('aria-hidden');
      });
      const getElement = document.querySelectorAll(".disabled");

      getElement.forEach(element => {
        element.setAttribute('aria-hidden', 'true');
      });
    }
  }
  updateButtonTranslation() {

    this.currentLang = sessionStorage.getItem("currLang");
    if (this.isIos) {
      const disabledDates = document.querySelectorAll('[class="ngb-dp-day disabled"]');
      disabledDates.forEach(function (el) {
        el.setAttribute('aria-hidden', 'true');
      });
    }
    const enabledDates = document.querySelectorAll('[class="ngb-dp-day"]');
    enabledDates.forEach(function (el) {
      el.removeAttribute('aria-hidden');
    });
    const prev = document.querySelector('[title="Previous month"]');
    const next = document.querySelector('[title="Next month"]');
    const month = document.querySelector('[title="Select month"]');
    const year = document.querySelector('[title="Select year"]');
    month.setAttribute('id', 'month');
    year.setAttribute('id', 'year');
    prev.setAttribute('id', 'prev');
    next.setAttribute('id', 'next');
    year.scrollHeight.toFixed;
    if (this.currentLang == 'fr') {
      prev.setAttribute('title', '');
      prev.setAttribute('aria-label', 'Le mois précédent');
      next.setAttribute('title', '');
      next.setAttribute('aria-label', 'Le mois prochain');
      month.setAttribute('title', '');
      month.setAttribute('aria-label', 'Sélectionnez un mois');
      year.setAttribute('title', '');
      year.setAttribute('aria-label', 'Sélectionnez l\'année');
    } else {
      prev.setAttribute('title', '');
      prev.setAttribute('aria-label', 'Previous month');
      next.setAttribute('title', '');
      next.setAttribute('aria-label', 'Next month');
      month.setAttribute('title', '');
      month.setAttribute('aria-label', 'Select month');
      year.setAttribute('title', '');
      year.setAttribute('aria-label', 'Select year');
    }
    prev.addEventListener('click', () => {
      const prev1 = document.querySelector('[id="prev"]');
      var e = (document.getElementById("month") as any);
      var e1 = (document.getElementById("year") as any);
      var date = e.options[e.selectedIndex].text + " " + e1.options[e1.selectedIndex].text;
      document.getElementById("dateSelected").innerHTML = date;
      if ((document.getElementById("prev") as any).disabled) {
        next.setAttribute('tabindex', '0');
        document.getElementById("next").focus();
      }
    });

    next.addEventListener('click', () => {
      const next1 = document.querySelector('[id="next"]');
      var e = (document.getElementById("month") as any);
      var e1 = (document.getElementById("year") as any);
      var date = e.options[e.selectedIndex].text + " " + e1.options[e1.selectedIndex].text;
      document.getElementById("dateSelected").innerHTML = date;
      if ((document.getElementById("next") as any).disabled) {
        prev.setAttribute('tabindex', '0');
        document.getElementById("prev").focus();
      }
    });

    var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    var android = !!navigator.platform && /Linux/.test(navigator.platform);
    if (ios || android) {
      document.getElementById("month").onchange = function () {

        const removeElement = document.querySelectorAll(".ngb-dp-day");

        removeElement.forEach(element => {
          element.removeAttribute('aria-hidden');
        });
        const getElement = document.querySelectorAll(".disabled");

        getElement.forEach(element => {
          element.setAttribute('aria-hidden', 'true');
        });

      }
      document.getElementById("year").onchange = function () {
        const removeElement = document.querySelectorAll(".ngb-dp-day");

        removeElement.forEach(element => {
          element.removeAttribute('aria-hidden');
        });
        const getElement = document.querySelectorAll(".disabled");

        getElement.forEach(element => {
          element.setAttribute('aria-hidden', 'true');
        });
      }
      document.getElementById("prev").onclick = function () {

        const removeElement = document.querySelectorAll(".ngb-dp-day");

        removeElement.forEach(element => {
          element.removeAttribute('aria-hidden');
        });
        const getElement = document.querySelectorAll(".disabled");

        getElement.forEach(element => {
          element.setAttribute('aria-hidden', 'true');
        });

      }
      document.getElementById("next").onclick = function () {
        const removeElement = document.querySelectorAll(".ngb-dp-day");

        removeElement.forEach(element => {
          element.removeAttribute('aria-hidden');
        });
        const getElement = document.querySelectorAll(".disabled");

        getElement.forEach(element => {
          element.setAttribute('aria-hidden', 'true');
        });

      }
    }
  }

  TempSave() {

    let day = this.aboutForm.value.DOB.day;
    if (day < 10) {
      day = "0" + day;
    }
    let month = this.aboutForm.value.DOB.month;
    if (month < 10) {
      month = "0" + month;
    }
    let dateofbirth = this.aboutForm.value.DOB.year + "-" + month + "-" + day;

    let tempObj = {
      "firstname": this.aboutForm.value.firstName,
      "lastname": this.aboutForm.value.lastName,
      "date_of_birth": dateofbirth
    }

    if (this.isIos) {
      sessionStorage.setItem("tempAboutYourselve", JSON.stringify(tempObj));
    }

  }

  coapplicantTempSave() {

    let day = this.coapplicantAboutForm.value.DOB.day;
    if (day < 10) {
      day = "0" + day;
    }
    let month = this.coapplicantAboutForm.value.DOB.month;
    if (month < 10) {
      month = "0" + month;
    }
    let dateofbirth = this.coapplicantAboutForm.value.DOB.year + "-" + month + "-" + day;

    let tempObj = {
      "firstname": this.coapplicantAboutForm.value.firstName,
      "lastname": this.coapplicantAboutForm.value.lastName,
      "date_of_birth": dateofbirth
    }

    if (this.isIos) {
      sessionStorage.setItem("tempAboutCoapplicant", JSON.stringify(tempObj));
    }

  }

  ngOnDestroy() {

  }
}